import { configureStore } from '@reduxjs/toolkit';
import authSlice, { getProfile } from './slices/authSlice';
import mapSlice from './slices/mapSlice';
import videoSlice from './slices/videoSlice';
import socialSlice from './slices/socialSlice';
import websocketSlice from './slices/websocketSlice';
import notificationSlice from './slices/notificationSlice';
import hashtagSlice from './slices/hashtagSlice';
import likesSlice from './slices/likesSlice';
import messagesSlice from './slices/messagesSlice';
import friendsSlice from './slices/friendsSlice';
import blockSlice from './slices/blockSlice';
import groupsSlice from './slices/groupsSlice';
import moderationSlice from './slices/moderationSlice';
import commentsSlice from './slices/commentsSlice';

// Middleware для автоматического вызова getProfile() после успешного логина
const authMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  // next(action) синхронно обновляет Redux state, setTimeout не нужен
  if (action.type === 'auth/login/fulfilled') {
    store.dispatch(getProfile());
  }
  return result;
};

export const store = configureStore({
  reducer: {
    auth: authSlice,
    map: mapSlice,
    video: videoSlice,
    social: socialSlice,
    websocket: websocketSlice,
    notifications: notificationSlice,
    hashtags: hashtagSlice,
    likes: likesSlice,
    messages: messagesSlice,
    friends: friendsSlice,
    block: blockSlice,
    groups: groupsSlice,
    moderation: moderationSlice,
    comments: commentsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(authMiddleware),
});